// plop_marker:layouts_import
import AdaChatbotTestIframe from "./ada-chatbot-test-iframe/index.js";
import AdaChatbotIframe from "./ada-chatbot-iframe/index.js";
import HubspotDynamicFormIframe from "./hubspot-dynamic-form-iframe/index.js";
import HubspotDynamicFormWithBulletsSideBySideIframe from "./hubspot-dynamic-form-with-bullets-side-by-side-iframe/index.js";
import EmbeddedBoardIframe from "./embedded-board-iframe/index.js";
import SideBySideHubspotForm from "./side-by-side-hubspot-form/index.js";
import IframeDynamicWidthIframe from "./iframe-dynamic-width-iframe/index.js";
export default {
    // plop_marker:layouts_add_layout
    AdaChatbotTestIframe,
    AdaChatbotIframe,
    HubspotDynamicFormIframe,
    HubspotDynamicFormWithBulletsSideBySideIframe,
    EmbeddedBoardIframe,
    SideBySideHubspotForm,
    IframeDynamicWidthIframe
};
